export const DEFAULT_CURRENCY = 'USD';
export const DEFAULT_CURRENCY_SYMBOL = '$';

/**
 * SINGLE SOURCE OF TRUTH for all currency data.
 * To add a new currency, just add one entry here — all derived maps update automatically.
 * The `id` must match the database `currencies` table primary key.
 */
const CURRENCY_DATA = [
  { id: 1, code: 'USD', symbol: '$' },
  { id: 2, code: 'EUR', symbol: '€' },
  { id: 3, code: 'CAD', symbol: 'C$' },
  { id: 4, code: 'AUD', symbol: 'A$' },
  { id: 5, code: 'PHP', symbol: '₱' },
  { id: 6, code: 'GBP', symbol: '£' },
  { id: 7, code: 'BGN', symbol: 'лв' },
  { id: 8, code: 'INR', symbol: '₹' },
  { id: 9, code: 'CNY', symbol: '¥' },
  { id: 10, code: 'MYR', symbol: 'RM' },
  { id: 11, code: 'SGD', symbol: 'S$' },
];

// Code → symbol: { USD: '$', EUR: '€', ... }
export const CURRENCIES = Object.fromEntries(CURRENCY_DATA.map(({ code, symbol }) => [code, symbol]));

// ID → symbol: { 1: '$', 2: '€', ... }
export const currenciesSymbolHash = Object.fromEntries(CURRENCY_DATA.map(({ id, symbol }) => [id, symbol]));
